/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeresponserefused2Inputs */

const en_outcomeresponserefused2 = /** @type {(inputs: Outcomeresponserefused2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refused or denied responsibility`)
};

const pt_outcomeresponserefused2 = /** @type {(inputs: Outcomeresponserefused2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recusou ou negou responsabilidade`)
};

/**
* | output |
* | --- |
* | "Refused or denied responsibility" |
*
* @param {Outcomeresponserefused2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeresponserefused2 = /** @type {((inputs?: Outcomeresponserefused2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeresponserefused2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeresponserefused2(inputs)
	return pt_outcomeresponserefused2(inputs)
});
export { outcomeresponserefused2 as "outcomeResponseRefused" }